import { render, staticRenderFns } from "./FriendshipLink.vue?vue&type=template&id=f79fe9f4&scoped=true"
import script from "./FriendshipLink.vue?vue&type=script&lang=js"
export * from "./FriendshipLink.vue?vue&type=script&lang=js"
import style0 from "./FriendshipLink.vue?vue&type=style&index=0&id=f79fe9f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79fe9f4",
  null
  
)

export default component.exports